import { render, staticRenderFns } from "./SetTopForm.vue?vue&type=template&id=47caed7d&scoped=true"
import script from "./SetTopForm.vue?vue&type=script&lang=js"
export * from "./SetTopForm.vue?vue&type=script&lang=js"
import style0 from "./SetTopForm.vue?vue&type=style&index=0&id=47caed7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47caed7d",
  null
  
)

export default component.exports